export enum HhTariff {
    CrossCivBundle = 'CROSS_CIV_BUNDLE',
    CrossCivVpplBundle = 'CROSS_CIV_VPPL_BUNDLE',
    CrossCivZp = 'CROSS_CIV_ZP',
}

export const isHhTariff = (tariff: string): boolean => Object.values(HhTariff).includes(tariff);
